import { ZoneContextManager } from '@opentelemetry/context-zone';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { Resource } from '@opentelemetry/resources';
import { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_NAMESPACE } from '@opentelemetry/semantic-conventions';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import type { AigwRuntimeConfig } from '../config';

export function initOtel(cfg: AigwRuntimeConfig): void {
  // No collector endpoint (e.g. deployed: there is no public OTel ingress for Morabi) — skip browser
  // tracing entirely rather than POST spans to a dead host.
  if (!cfg.otelEndpoint) return;

  const provider = new WebTracerProvider({
    resource: new Resource({
      [ATTR_SERVICE_NAME]: 'aigw-morabi-web',
      [ATTR_SERVICE_NAMESPACE]: 'aigw',
      'deployment.environment': cfg.envName
    }),
    spanProcessors: [
      new BatchSpanProcessor(
        new OTLPTraceExporter({ url: `${cfg.otelEndpoint.replace(/\/$/, '')}/v1/traces` })
      )
    ]
  });

  provider.register({ contextManager: new ZoneContextManager() });

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: [new RegExp(`^${escapeForRegex(cfg.apiUrl)}`)],
        clearTimingResources: true
      })
    ]
  });
}

function escapeForRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
